import React from "react";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import withRouter from "../../components/withRouter/withRouter";

import { toast } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "../products/products.module.css";
import { faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import { addUpdateApi, getAllApi, getByIdApi, uploadImageApi } from "../../api";
import he from "he";
import { isValidURL } from "../../utils/isValidUrl";

class AddCompliance extends React.Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    title: "",
    body: "",
    typeName: "",
    company: "",
    allCompliances: [],
    terms: true,
    privacy: true,
    returnPolicy: true,
    cancellationPolicy: true,
    dataPolicy: true,
    loading: false,
    refund: true,
    ip: true,
    cookie: true,
    sitemap: true,
    return: true,
    shipping: true,
    legalDetails: true,
    about: true,
    businessName: "",
    typeOfBusiness: "",
    businessCategory: "",
    registrationDate: "",
    businessSubCategory: "",
    officeAddress: {},
    invoicePhoneNumber: "",
    invoiceEmail: "",
    cin: "",
    gst: "",
    PAN: "",
    logoUrl: "",
    metaDescription: "",
    metaImageUrl: "",
    slug: "",
    metaTitle: "",
    canonicalUrl: "",
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
      isImageChanged: true,
    });
  };

  componentDidMount() {
    this.checkPage();
    this.get();
  }

  handleDropDown = () => {
    //  "ip", "cookie", "sitemap"

    const temp = [
      {
        title: "Terms Of Use",
        value: "terms",
        disabled: !this.state.terms,
      },
      {
        title: "Privacy Policy",
        value: "privacy",
        disabled: !this.state.privacy,
      },
      {
        title: "Shipping",
        value: "shipping",
        disabled: !this.state.shipping,
      },
      {
        title: "Cancellation Policy",
        value: "cancellation",
        disabled: !this.state.cancellationPolicy,
      },
      {
        title: "Return Policy",
        value: "return",
        disabled: !this.state.return,
      },
      {
        title: "Refund Policy",
        value: "refund",
        disabled: !this.state.refund,
      },
      {
        title: "Data Policy",
        value: "data",
        disabled: !this.state.dataPolicy,
      },
      { title: "IP Policy", value: "ip", disabled: !this.state.ip },
      {
        title: "Cookie Policy",
        value: "cookie",
        disabled: !this.state.cookie,
      },
      { title: "Sitemap", value: "sitemap", disable: !this.state.cookie },
      {
        title: "Legal Details",
        value: "legalDetails",
        disable: !this.state.legalDetails,
      },
      {
        title: "About",
        value: "about",
        disable: !this.state.about,
      },
    ];

    return temp;
  };

  get = () => {
    getAllApi("compliance")
      .then((res) => {
        let dd = res.data;
        this.setState({ allCompliances: dd, loading: false });

        dd.forEach((element) => {
          if (element.complianceType === "terms") {
            this.setState({ terms: false });
          }
          if (element.complianceType === "privacy") {
            this.setState({ privacy: false });
          }
          if (element.complianceType === "dataPolicy") {
            this.setState({ dataPolicy: false });
          }
          if (element.complianceType === "cancellation") {
            this.setState({ cancellationPolicy: false });
          }
          if (element.complianceType === "returnPolicy") {
            this.setState({ returnPolicy: false });
          }
          if (element.complianceType === "shipping") {
            this.setState({ shipping: false });
          }
          if (element.complianceType === "about") {
            this.setState({ about: false });
          }
        });
      })
      .catch(() => {});
  };

  addLegaldetail = () => {
    // axios({
    //   url: `https://backend.cftcommerce.com/api/compliances`,
    //   method: "post",
    //   data: {
    //     identifier: localStorage.getItem("identifier"),
    //     typeName: this.state.typeName,
    //     company: this.state.company,
    //     title: this.state.title,
    //     body: this.state.body,
    //   },
    // })
    //   .then((res) => {
    //     toast.success(res.data.message);
    //     this.props.router.navigate("/compliance");
    //     this.setState({ loading: false });
    //   })
    //   .catch((err) => {
    //     toast.error(err.response.data.message);
    //     this.setState({ loading: false });
    //   });
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Banner image is required.");
      return false;
    }

    if (!this.state.imageCaption) {
      toast.error("Image caption is required.");
      return false;
    }

    if (!this.state.imageAlt) {
      toast.error("Image alt is required.");
      return false;
    }

    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }

    if (!this.state.typeName) {
      toast.error("Type is required.");
      return false;
    }

    if (!this.state.body) {
      toast.error("Body is required.");
      return false;
    }

    if (!this.state.slug) {
      toast.error("Slug is required.");
      return false;
    }

    if (!this.state.metaTitle) {
      toast.error("Meta title is required.");
      return false;
    }

    if (!this.state.metaImageUrl) {
      toast.error("Meta Image Url is required.");
      return false;
    }

    if (!isValidURL(this.state.metaImageUrl)) {
      toast.error("Meta Image Url is invalid.");
      return false;
    }

    if (!this.state.canonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }

    if (!isValidURL(this.state.canonicalUrl)) {
      toast.error("Canonical Url is invalid.");
      return false;
    }

    if (!this.state.metaDescription) {
      toast.error("Meta Description is required.");
      return false;
    }

    return true;
  };

  handleClick = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/compliance");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });

        addUpdateApi({
          data: {
            title: this.state.title,
            complianceType: this.state.typeName,
            description: this.state.body,
            metaData: {
              metaDescription: this.state.metaDescription,
              metaImageUrl: this.state.metaImageUrl,
              slug: this.state.slug,
              metaTitle: this.state.metaTitle,
              canonicalUrl: this.state.canonicalUrl,
            },
          },
          type: "compliance",
          method: "post",
        })
          .then(() => {
            toast.success("Created successfully.");
            this.props.router.navigate("/compliance");
          })
          .catch((err) => {
            console.log(err);
            toast.error("Error while creating compliance.");
            this.setState({ loading: false });
          });
      }
    }
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "technology"
        );

        return response.data.imageUrl;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  handleUpdate = async (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/compliance");
    } else {
      this.setState({ loading: true });

      const img_url = await this.uploadImage();

      addUpdateApi({
        data: {
          title: this.state.title,
          complianceType: this.state.typeName,
          description: this.state.body,
          bannerImage: img_url,
          altImage: this.state.imageAlt,
          imageCaption: this.state.imageCaption,
          metaData: {
            metaDescription: this.state.metaDescription,
            metaImageUrl: this.state.metaImageUrl,
            slug: this.state.slug,
            metaTitle: this.state.metaTitle,
            canonicalUrl: this.state.canonicalUrl,
          },
        },
        type: "compliance",
        method: "patch",
        id: this.props.router.params.id,
      })
        .then(() => {
          toast.success("Updated successfully.");
          this.props.router.navigate("/compliance");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error while updating compliance.");
          this.setState({ loading: false });
        });
    }
  };

  getData = () => {
    getByIdApi("compliance", this.props.router.params?.id)
      .then((res) => {
        console.log("compliance daaaaaa ;;;;;; ", res.data);
        this.setState({
          typeName: res.data.complianceType,
          title: res.data?.title,
          body: he.decode(res.data?.description || ""),
          metaDescription: res.data?.metaData?.metaDescription || "",
          metaImageUrl: res.data?.metaData?.metaImageUrl || "",
          slug: res.data?.metaData?.slug || "",
          metaTitle: res.data?.metaData?.metaTitle || "",
          canonicalUrl: res.data?.metaData?.canonicalUrl || "",
          imageUrl: res.data?.bannerImage,
          imageAlt: res.data?.altImage,
          imageCaption: res.data?.imageCaption,
        });
      })
      .catch((err) => {});
  };

  checkPage = () => {
    if (this.props.router.params.id) {
      this.setState({ loading: true });
      this.getData();
    }
  };

  handleChangeAddress = (event) => {
    const { name, value } = event.target;
    console.log(name, value);
    // let temp={...this.state.officeAddress}

    this.setState({
      officeAddress: { ...this.state.officeAddress, [name]: value },
    });
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={
              this.props.router.params.id
                ? "Update Compliance"
                : "Add Compliance"
            }
            showBtn1={true}
            showBtn2={false}
            showBtn3={true}
            btn1Name="btn1"
            btn2Name="btn2"
            btn3Name="btn3"
            btn1Text="Save"
            btn2Text="Save as Draft"
            btn3Text="Cancel"
            btn2type="outlined"
            btn1type="filled"
            btn3type="outlined_del"
            onClickHandler={
              this.props.router.params.id ? this.handleUpdate : this.handleClick
            }
          />
          <ContentBody>
            <div className="grid">
              <div className="grid card">
                <div>
                  <p
                    style={{
                      fontSize: ".9",
                      transform: "translateX(5px)",
                      marginTop: "10px",
                    }}
                  >
                    Banner Image
                    <span
                      style={{ color: "#a3a3a3", fontSize: ".8rem" }}
                    ></span>
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        margin: "10px",
                        cursor: "pointer",
                        position: "relative",
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div style={{ width: "45%", marginBottom: "40px" }}>
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "16/9",
                          backgroundImage: `url('${
                            this.props.router.params.id
                              ? this.state.isImageChanged
                                ? this.state.imageUrl
                                : this.state.imageUrl
                              : this.state.imageUrl
                          }')`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          marginTop: "10px",
                          borderRadius: "15px",
                          position: "relative",
                        }}
                      ></div>
                      {this.state.imageObject && (
                        <p style={{ textAlign: "center" }}>
                          {this.state.imageObject.name}
                        </p>
                      )}
                    </div>
                  )}

                  {this.state.imageUrl && (
                    <div className="grid_2">
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Caption"}
                        value={this.state.imageCaption}
                        onChange={(e) => {
                          this.setState({ imageCaption: e.target.value });
                        }}
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Image Alt"}
                        value={this.state.imageAlt}
                        onChange={(e) =>
                          this.setState({ imageAlt: e.target.value })
                        }
                      />
                    </div>
                  )}
                </div>
                <div className="grid">
                  <InputField
                    type={"text"}
                    isLabel={true}
                    lable="Title"
                    value={this.state.title}
                    onChange={(event) => {
                      this.setState({ title: event.target.value });
                    }}
                    placeholder="Enter Title"
                  />
                  <InputField
                    type={"select"}
                    isLabel={true}
                    lable="Type"
                    options={this.handleDropDown()}
                    accessText="title"
                    accessValue="value"
                    value={this.state.typeName}
                    onChange={(event) => {
                      this.setState({ typeName: event.target.value });
                    }}
                  />

                  <div style={{ width: "100%" }}>
                    <TextEditor
                      content={this.state.body}
                      handleChange={(val) => {
                        this.setState({ body: val });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="card grid">
                <h3>Meta Data</h3>
                <InputField
                  isLabel={true}
                  lable="Slug"
                  type="text"
                  value={this.state.slug}
                  onChange={(e) =>
                    this.setState({ slug: e.target.value.replace(" ", "-") })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Title"
                  type="text"
                  value={this.state.metaTitle}
                  onChange={(e) => this.setState({ metaTitle: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Image Url"
                  type="text"
                  value={this.state.metaImageUrl}
                  onChange={(e) =>
                    this.setState({ metaImageUrl: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Canonical Url"
                  type="text"
                  value={this.state.canonicalUrl}
                  onChange={(e) =>
                    this.setState({ canonicalUrl: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Description"
                  type="textarea"
                  value={this.state.metaDescription}
                  onChange={(e) =>
                    this.setState({ metaDescription: e.target.value })
                  }
                />
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

const isUserAllowedToEdit = (admin) => {
  if (admin.role !== "subadmin") return true;

  if (admin.role === "subadmin" && admin.compliance_access.write) return true;

  return false;
};

export default withRouter(AddCompliance);
